import { defineMessage } from 'react-intl';

export const dateTimeCommonI18n = {
  year: defineMessage({
    id: 'common:date-time.year',
    defaultMessage: 'Year'
  }),
  month: defineMessage({
    id: 'common:date-time.month',
    defaultMessage: 'Month'
  }),
  day: defineMessage({
    id: 'common:date-time.day',
    defaultMessage: 'Day'
  }),

  meridiemAm: defineMessage({
    id: 'common:date-time.meridiem-am',
    defaultMessage: 'AM'
  }),
  meridiemPm: defineMessage({
    id: 'common:date-time.meridiem-pm',
    defaultMessage: 'PM'
  }),

  dayOfWeek: defineMessage({
    id: 'common:date-time.day-of-week',
    defaultMessage: 'Day of the week'
  }),
  monthNthDay: defineMessage({
    id: 'common:date-time.month-nth-day',
    defaultMessage: '{day, selectordinal, one {#st} two {#nd} few {#rd} other {#th}}'
  }),

  currentWeek: defineMessage({
    id: 'common:date-time.current-week',
    defaultMessage: 'Current week'
  }),
  nextWeek: defineMessage({
    id: 'common:date-time.next-week',
    defaultMessage: 'Next week'
  }),
  previousWeek: defineMessage({
    id: 'common:date-time.previous-week',
    defaultMessage: 'Last week'
  }),

  bookedOnDate: defineMessage({
    id: 'common:date-time.booked-date',
    defaultMessage: 'Booked on {date}'
  }),
  bookedTimeAgo: defineMessage({
    id: 'common:date-time.booked-time-ago',
    defaultMessage: 'Booked {timeAgo}'
  }),
  joinedOnDate: defineMessage({
    id: 'common:date-time.joined-date',
    defaultMessage: 'Joined on {date}'
  }),
  joinedTimeAgo: defineMessage({
    id: 'common:date-time.joined-time-ago',
    defaultMessage: 'Joined {timeAgo}'
  }),
  lastUpdatedAtDate: defineMessage({
    id: 'common:date-time.last-updated-date',
    defaultMessage: 'Last updated on {date}'
  }),
  lastUpdatedTimeAgo: defineMessage({
    id: 'common:date-time.last-updated-time-ago',
    defaultMessage: 'Last updated {timeAgo}'
  }),
  publishedOnDate: defineMessage({
    id: 'common:date-time.published-date',
    defaultMessage: 'Published on {date}'
  }),
  publishedTimeAgo: defineMessage({
    id: 'common:date-time.published-time-ago',
    defaultMessage: 'Published {timeAgo}'
  }),
  savedOnDate: defineMessage({
    id: 'common:date-time.saved-date',
    defaultMessage: 'Saved on {date}'
  }),
  savedTimeAgo: defineMessage({
    id: 'common:date-time.saved-time-ago',
    defaultMessage: 'Saved {timeAgo}'
  }),
  updatedOnDate: defineMessage({
    id: 'common:date-time.updated-date',
    defaultMessage: 'Updated on {date}'
  }),
  updatedTimeAgo: defineMessage({
    id: 'common:date-time.updated-time-ago',
    defaultMessage: 'Updated {timeAgo}'
  })
};
